import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { FinalVersionDocument } from "../../../../models/workflow.model";
import moment from "moment";
import DocumentDownload from "../../../../components/DocumentDownload";
import { useTranslation } from "react-i18next";
import styles from "./FinalVersion.module.scss";
import { RemoveIcon } from "../../../../assets/icons";

const FinaVersionDocuments: React.FC<{ documents: FinalVersionDocument[]; onDelete?: (index: number) => void }> = ({
  documents,
  onDelete,
}) => {
  const { t } = useTranslation();

  return (
    <TableContainer className={styles.documentView}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell className={styles.uploadBy}>{t("uploadBy")}</TableCell>
            <TableCell className={styles.uploadDate}>{t("uploadDate")}</TableCell>
            <TableCell className={styles.language}>{t("language")}</TableCell>
            <TableCell className={styles.document}>{t("document")}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {documents.map((x, index) => (
            <TableRow key={`document_view_id_${x.id}`}>
              <TableCell className={styles.uploadBy}>{x.updatedBy}</TableCell>
              <TableCell className={styles.uploadDate}>
                {x.updatedDate ? moment(x.updatedDate).format("MM/DD/YYYY") : ""}
              </TableCell>
              <TableCell>{t(`languages.${x.language}`)}</TableCell>
              <TableCell className={styles.document}>
                <DocumentDownload documentId={x.id} />
                {onDelete && (
                  <IconButton
                    onClick={() => {
                      onDelete(index);
                    }}
                  >
                    <RemoveIcon />
                  </IconButton>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default FinaVersionDocuments;
